// views
import Link from "next/link";
import { Row, Col, Progress } from "antd";
import UserLevel from "~/components/users/UserLevel";
import expIcon from "~/public/static/icons/exp@3x.png";

export default (props) => {
  const { user } = props;
  const level = user.level_info;
  const percent =
    ((user.exp - level.exp_min) / (level.exp_max - level.exp_min)) * 100;

  return (
    <div className="mx-10 my-10">
      <Row type="flex" align="bottom" justify="space-between">
        <Col span={2}>
          <img src={expIcon.src} width={24} height={24} />
        </Col>
        <Col span={20}>
          <div className="mx-20 pos-relative">
            <span className="text-sm exp-value">
              {user.exp} / {user.level_info.exp_max}
            </span>
            <Progress
              strokeColor={{
                "0%": "#FBD249",
                "100%": "#F5A623",
              }}
              showInfo={false}
              percent={percent}
            />
          </div>
        </Col>
        <Col span={2}>
          <UserLevel level={level} />
        </Col>
      </Row>
      <Row type="flex" align="bottom" justify="space-between">
        <Col span={20} offset={2}>
          <div className="mx-20">
            <div className="my-5">
              <span className="text-secondary">经验</span>
            </div>
            <div className="my-5">
              {props.profile && (
                <Link legacyBehavior href="/exp_records">
                  <a className="ant-btn ant-btn-primary ant-btn-sm ant-btn-background-ghost">
                    查看详情
                  </a>
                </Link>
              )}
            </div>
          </div>
        </Col>
      </Row>

      <style jsx>
        {`
          .exp-value {
            position: absolute;
            top: -12px;
          }
        `}
      </style>
    </div>
  );
};
